import React from 'react';
import { isEmpty } from 'lodash';
import { DTOrderSearchView } from '../../DTOrderSearchView';
import { processRbiOrderIssueCoupon } from '../../../../../../actions/tools/DecisionTree/RBIActions';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedOrder } from '../../../../../../selectors/tools';
import { selectSearchPageLoading } from '../../../../../../selectors/searchPage';
import { OrderItemsSettingsContextProvider } from '../../Common/SearchResults/Common/DTOrderSearchResult/OrderItemsWrapper/OrderItemsSettingsContext';
import RBIItems from '../../Common/SearchResults/Common/DTOrderSearchResult/OrderItemsWrapper/RBIItems/RBIItems';

const DTSelectOrderRBICouponIssueNode = () => {
  const dispatch = useDispatch();
  const selectedOrder = useSelector(getSelectedOrder);
  const isLoading = useSelector(selectSearchPageLoading);

  const handleNextButtonClick = async () => {
    await dispatch(processRbiOrderIssueCoupon());
  };

  return (
    <OrderItemsSettingsContextProvider value={{ component: RBIItems, allSubItemsSelected: true }}>
      <DTOrderSearchView
        onNextButtonClick={handleNextButtonClick}
        isNextButtonActive={!isEmpty(selectedOrder) && !isLoading}
      />
    </OrderItemsSettingsContextProvider>
  );
};

export default DTSelectOrderRBICouponIssueNode;
